<template>
    <div :class="['guide-builder-chat-panel', { 'guide-builder-chat-panel--sidebar': showHeader }]">
        <template v-if="showHeader">
            <div class="guide-builder-chat-panel__header">
                <div class="guide-builder-chat-panel__header-left">
                    <pendo-icon-button
                        icon="arrow-left"
                        icon-size="16"
                        :aria-label="$t('Back')"
                        @click="$emit('back')" />
                    <span class="guide-builder-chat-panel__title">{{ $t('guideBuilderChatPanel.Guide agent') }}</span>
                </div>
            </div>
            <pendo-divider v-bind="{ strokeWidth: 1, height: '1px' }" />
        </template>
        <ask-pendo-thread
            :input-placeholder="inputPlaceholder"
            :messages="messages"
            :conversation-id="conversationId"
            :agent-id="agentId"
            :pending="pending"
            :error="error"
            :custom-button-icon="`arrow-right`"
            is-guide-chat
            :should-show-llm-undo="shouldShowLlmUndo"
            @update="$emit('update', $event)"
            @stop="$emit('stop')"
            @undo-llm-change="$emit('undo-llm-change')">
            <template
                #loading
                v-if="pending">
                <ai-chat-loading is-guide-chat />
            </template>
        </ask-pendo-thread>
    </div>
</template>

<script>
import { PendoDivider, PendoIconButton } from '@pendo/components';
import AskPendoThread from '@/ask-pendo/components/ask-pendo-thread.vue';
import AiChatLoading from '@/voc/components/ai-chat-loading/ai-chat-loading.vue';

export default {
    name: 'GuideBuilderChatPanel',
    components: {
        AiChatLoading,
        AskPendoThread,
        PendoDivider,
        PendoIconButton,
    },
    props: {
        messages: {
            type: Array,
            default: () => [],
        },
        conversationId: {
            type: String,
            default: '',
        },
        agentId: {
            type: String,
            default: '',
        },
        pending: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: '',
        },
        shouldShowLlmUndo: {
            type: Boolean,
            default: false,
        },
        showHeader: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update', 'stop', 'undo-llm-change', 'back'],
    created () {
        this.inputPlaceholder = this.$t('guideBuilderChatPanel.Write your answer');
    },
};
</script>

<style lang="less" scoped>
.guide-builder-chat-panel {
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    width: 512px;
    height: 100%;
    position: relative;
    z-index: 2;
    background-color: var(--palette-gray-0);
    transition: transform 0.3s ease-in;

    > * {
        flex: 1;
        min-height: 0;
    }

        &--sidebar {
            width: 500px;
        border-left: 1px solid var(--palette-gray-40);

        > * {
            flex: unset;
            min-height: unset;
        }
    }

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        flex: 0 0 auto;
        height: 56px;
    }

    &__header-left {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    &__title {
        font-size: 14px;
        font-weight: 600;
        color: var(--palette-gray-100);
    }

    :deep(.ask-pendo-thread) {
        flex: 1;
        min-height: 0;
        padding: 0;
    }

    :deep(.ask-pendo-message:first-child) {
        h2 {
            margin-top: 2px;
        }
    }

    :deep(.ask-pendo-thread__messages-container) {
        padding: 24px 16px 0;
    }

    :deep(.ask-pendo-thread__input) {
        padding-bottom: 0;
    }

    :deep(.ask-pendo-message__guide-chat) {
        padding-left: 0;
        padding-right: 0;
    }

    :deep(.ask-pendo-message__content) {
        padding-right: 8px;
    }

    :deep(.ask-pendo-thread__feedback-row) {
        margin-left: 24px;
    }
}
</style>
